<script setup lang="ts">
type ProductCardTitleProps = {
  productName: string | undefined
  productUrl: string
}

const props = defineProps<ProductCardTitleProps>()
</script>

<template>
  <div v-if="productName" class="product-card__title" data-testid="product-card-name">
    <Anchor :url="productUrl" class="product-card__name" variant="text">{{ productName }}</Anchor>
  </div>
</template>

<style lang="postcss">
.product-card__name {
  font-size: 1rem;
  font-weight: bold;
  text-decoration: none;
  display: block;
}
</style>
